const initialEditorState = () => {
  return {
    email: '',
    password: '',
  };
};

export default initialEditorState;
